import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DRAWINGSTATE, MAPMODE } from '../map/map-state-control';

export const ProcessProgressActions = createActionGroup({
  source: 'ProcessProgress',
  events: {
    'set step': props<{ stepCounter: number, processMode: MAPMODE }>(),

    'request next step': emptyProps(), // requests effect for new process step
    'take next step': props<{ processLabel: string, drawingState: DRAWINGSTATE }>(), //updates actual state

    'request step back': emptyProps(),
    'take step back': props<{ processLabel: string }>(),

    'finish process': props<{ assignedName: string }>(),

    'reset process': emptyProps(),
    'cancel process': emptyProps(),
  },
});
